import { createElement } from "react";
import {
  createRoute,
  lazyRouteComponent,
  type AnyRoute,
} from "@tanstack/react-router";

import type { FeatureRouteContext } from "@nasam/kernel";
import type { ProfileRepository } from "../../domain";

const ProfileScreen = lazyRouteComponent(
  () => import("../ProfileScreen"),
  "ProfileScreen",
);
const ProfileEditScreen = lazyRouteComponent(
  () => import("../ProfileEditScreen"),
  "ProfileEditScreen",
);
const SecurityScreen = lazyRouteComponent(
  () => import("../SecurityScreen"),
  "SecurityScreen",
);

export interface ProfileRouteDeps {
  readonly context: FeatureRouteContext;
  readonly repository: ProfileRepository;
}

/** No permission gate: every signed-in user has a profile. */
export function createProfileRoutes({
  context,
  repository,
}: ProfileRouteDeps): AnyRoute[] {
  const basePath = context.basePath;

  return [
    createRoute({
      getParentRoute: context.getParentRoute,
      path: basePath,
      component: () => createElement(ProfileScreen, { repository, basePath }),
    }),
    createRoute({
      getParentRoute: context.getParentRoute,
      path: `${basePath}/edit`,
      component: () =>
        createElement(ProfileEditScreen, { repository, basePath }),
    }),
    createRoute({
      getParentRoute: context.getParentRoute,
      path: `${basePath}/security`,
      component: () => createElement(SecurityScreen, { repository }),
    }),
  ];
}
